export default __webpack_public_path__ + "static/ecotalk-map-8e55b803606ff75725915ae98a7ab98e.png";